import EventEmitter from 'events'

/*
  Class for managing subscriptions with Sport Data updates
  Currenty available:
    - Outcome
    - Event
    - Tournament
*/
export default class UpdatesBroadcaster extends EventEmitter {
  subscribeToEventUpdates (eventId, eventUpdateHandler) {
    const eventName = `event:${eventId}`

    return this.addListener(
      eventName,
      eventUpdateHandler
    )
  }

  unsubscribeFromEventUpdates (eventId, eventUpdateHandler) {
    const eventName = `event:${eventId}`

    return this.removeListener(
      eventName,
      eventUpdateHandler
    )
  }

  subscribeToTournamentUpdates (tournamentId, tournamentUpdateHandler) {
    const eventName = `tournament:${tournamentId}`

    return this.addListener(
      eventName,
      tournamentUpdateHandler
    )
  }

  unsubscribeFromTournamentUpdates (tournamentId, tournamentUpdateHandler) {
    const eventName = `tournament:${tournamentId}`

    return this.removeListener(
      eventName,
      tournamentUpdateHandler
    )
  }

  subscribeToCategoriesUpdates (categoryId, categoryUpdateHandler) {
    const eventName = `category:${categoryId}`

    return this.addListener(
      eventName,
      categoryUpdateHandler
    )
  }

  unsubscribeFromCategoriesUpdates (categoryId, categoryUpdateHandler) {
    const eventName = `category:${categoryId}`

    return this.removeListener(
      eventName,
      categoryUpdateHandler
    )
  }

  subscribeToSportUpdates (sportId, sportUpdateHandler) {
    const eventName = `sport:${sportId}`

    return this.addListener(
      eventName,
      sportUpdateHandler
    )
  }

  unsubscribeFromSportUpdates (sportId, sportUpdateHandler) {
    const eventName = `sport:${sportId}`

    return this.removeListener(
      eventName,
      sportUpdateHandler
    )
  }
}
